<div class="map" #resizeContainer>
  <div
    class="map__default"
    [hidden]="!!mapUrl"
    leaflet
    [leafletOptions]="leafletOptions"
    (leafletMapReady)="onMapReady($event)"
    (leafletZoomChange)="onZoomChange()">
    @if (isLoading && !mapUrl) {
      <div class="loader">
        <mat-spinner [diameter]="80"></mat-spinner>
        <span class="loader__text">Obtaining coordinates...</span>
      </div>
    }
  </div>
  @if (mapUrl) {
    <iframe [src]="mapUrl" class="map__windward"></iframe>
  }
</div>
